module.exports = __webpack_public_path__ + "img/geology-uranus.135c195e.png";